import React from 'react';
import { appointmentSessionRoute, CLIENT_STATUSES } from '@uplift/constants';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { CalendarDateService } from '@uplift/services';
import { Patient } from '@uplift/types';
import { Appointment } from '@uplift/api';

import { Link } from 'react-router-dom';
import { Button, ButtonProps } from '../../../../Button';


export const JoinSessionButton: React.FC<{
  patient?: Pick<Patient, 'status'>;
  appointment?: Appointment;
} & ButtonProps> = ({ patient, appointment, ...props }) => {
  const l10n = useL10n();
  const isMobile = useIsMobile();
  const joinSessionLink = appointment?.id ? appointmentSessionRoute.createLink({ appointmentId: appointment?.id }) : '';
  const isAbleToJoinSession = React.useMemo(() => {
    if (!patient || !appointment) {
      return false;
    }

    if (patient?.status !== CLIENT_STATUSES.regular) {
      return false;
    }

    const now = CalendarDateService.date();
    const isFinished2hoursAgo = CalendarDateService.date(appointment?.fromDatetime).isBefore(now.subtract(2, 'hours'));
    const isSessionScheduled = appointment?.state === 'scheduled' || appointment?.state === 'initial';
    const isSessionStarted = appointment?.state === 'started' && !isFinished2hoursAgo;
    const isExpired = isSessionScheduled && isFinished2hoursAgo;

    if (isExpired) {
      return false;
    }

    if (isSessionStarted) {
      return true;
    }

    const startIn30Minutes = CalendarDateService.date(appointment.fromDatetime).diff(now, 'minutes') <= 30;

    if (isSessionScheduled && startIn30Minutes) {
      return true;
    }

    return false;
  }, [ patient, appointment ]);

  return (
    <Button
      {...props}
      component={Link}
      to={joinSessionLink}
      disabled={props.disabled || !isAbleToJoinSession}
    >
      {isMobile ? l10n.sessions.join : l10n.sessions.joinSession}
    </Button>
  );
};
